import React, { FunctionComponent, useContext } from "react";
import { Switch, Route, Redirect, RouteProps, RouteComponentProps } from "react-router-dom";

import Dashboard from "../pages/Dashboard";
import UnitiesGroups from "../pages/UnitiesGroups";
import Login from "../pages/Login";
import ChangePassword from "../pages/Login/ChangePassword";
import ActualUpdate from "../pages/ActualUpdate";
import ActualUnitDetails from "../pages/ActualUpdate/UnitDetails";
import PlanUpdate from "../pages/PlanUpdate";
import PlanUnitDetails from "../pages/PlanUpdate/UnitDetails";
import CalendarManagement from "../pages/CalendarManagement";
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import NotFound from "../pages/NotFound";
import Scoreboard from "../pages/Scoreboard";
import System from "../pages/System";
import ChannelsManagement from "../pages/ChannelsManagement";
import AuthContext from "../contexts/AuthContext";

interface PrivateRouteProps extends RouteProps {
  basic?: boolean;
  component: | React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  redirectTo: string;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ component: Component, redirectTo, basic, ...rest }) => {
  const { user, logged } = useContext(AuthContext);

  return (
    <Route {...rest}
      render={(props) => {
        return logged ? (!user!.basicLayout || user!.profile.name !== "Sender" || basic ? (
          <Component {...props} />) : (
          <NotFound />
        ))
          : (<Redirect to={{ pathname: redirectTo, search: "?redirect_to=" + props.location.pathname, state: { from: props.location } }} />);
      }}
    />
  );
};
//}
const Routes = () => {
  const { user, logged } = useContext(AuthContext);

  const defaultPath: string = user ? (user?.basicLayout ? "/actual-update" : "/dashboard") : "/login";

  return (
    <React.Fragment>
      <Switch>
        <PrivateRoute path="/calendar-management" redirectTo="/login" component={CalendarManagement} />
        <PrivateRoute basic={true} path="/actual-update/:groupId/:currentYear/:monthId" redirectTo="/login" component={ActualUnitDetails} />
        <PrivateRoute basic={true} path="/actual-update" redirectTo="/login" component={ActualUpdate} />
        <PrivateRoute basic={true} path="/plan-update/:groupId/:currentYear/:monthId" redirectTo="/login" component={PlanUnitDetails} />
        <PrivateRoute basic={true} path="/plan-update" redirectTo="/login" component={PlanUpdate} />
        <PrivateRoute path="/unities-groups" redirectTo="/login" component={UnitiesGroups} />
        <PrivateRoute path="/users" redirectTo="/login" component={Users} />
        <PrivateRoute path="/channels-management" redirectTo="/login" component={ChannelsManagement} />
        <PrivateRoute basic={true}  path="/dashboard" redirectTo="/login" component={Dashboard} />
        <PrivateRoute path="/system" redirectTo="/" component={System} />
        <PrivateRoute basic={true} path="/profile" redirectTo="/login" component={Profile} />
        <Route exact path="/">
          <Redirect to={defaultPath} />
        </Route>
        <Route path="/login">
          {logged ? <Redirect to={defaultPath} /> : <Login />}
        </Route>
        <PrivateRoute basic={true} path="/scoreboard" redirectTo="/login" component={Scoreboard} />
        <Route path="/changepassword" component={ChangePassword} />
        {/* <PrivateRoute path="/trade-plan-rollback" redirectTo="/login" component={PlanRollBack} /> */}
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
